import styled from "styled-components";

export const Wrap = styled.div`
    width: 1186px;
margin 0 auto;
background-color: #fff;
display: flex;
align-items: center;
`;
